import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { groupBy } from 'lodash';

const useFormatInvestorAllocationsData = () => {
  const { getValues } = useFormContext<rules.CreateRealisationFormValues>();

  const formatInvestorAllocationsData = (index: number) => {
    const investorAllocations = getValues(
      `consideration.${index}.investorAllocations`,
    );

    const formattedInvestorAllocations = groupBy(
      investorAllocations,
      'investmentId',
    );

    return formattedInvestorAllocations;
  };

  return { formatInvestorAllocationsData };
};

export default useFormatInvestorAllocationsData;
